import { useMemo, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { QUERY_NOTIFICATION_LIST, DELETE_NOTIFICATION } from './queries';
import { message } from 'antd';

export const NotificationStatusLabel = {
  SCHEDULED: 'Scheduled',
  EXPIRED: 'Expired',
  ACTIVE: 'Active',
};
export function useData(props) {
  const { defaultPageSize = 10 } = props || {};
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: defaultPageSize,
  });

  const [queryFilter, setQueryFilter] = useState({
    name: '',
    status: '',
    publishType: '',
  });

  const resetPaginationAndFilter = () => {
    setPagination(current => ({
      ...current,
      pageNumber: 1,
    }));
    setQueryFilter({
      name: '',
      status: '',
      publishType: '',
    });
  };

  const {
    loading,
    data: queryResponse,
    refetch,
  } = useQuery(QUERY_NOTIFICATION_LIST, {
    variables: {
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
      filters: [
        ...(queryFilter.name ? [{ field: 'NAME', op: 'CONTAINS', value: queryFilter.name }] : []),
        ...(queryFilter.publishType
          ? [{ field: 'PUBLISH_TYPE', op: 'CONTAINS', value: queryFilter.publishType }]
          : []),
        ...(queryFilter.status ? [{ field: 'STATUS', value: queryFilter.status }] : []),
      ],
    },
    fetchPolicy: 'cache-and-network',
    onError: e => {
      message.error(e?.toString());
    },
  });

  const [deleteNotification, { loading: deleteLoading }] = useMutation(DELETE_NOTIFICATION, {
    onError: e => {
      message.error(e?.toString());
    },
    onCompleted: () => {
      message.success('Delete successfully');
      refetch();
    },
  });

  const list = useMemo(() => {
    return queryResponse?.listNotifications?.edges || [];
  }, [queryResponse]);

  const listTotalCount = useMemo(() => {
    return queryResponse?.listNotifications?.totalCount || 0;
  }, [queryResponse]);

  const advancedRefetch = ({ resetAll }) => {
    if (resetAll) {
      resetPaginationAndFilter();
    }
    refetch();
  };

  const advancedDelete = async variables => {
    await deleteNotification(variables);
    // if you delete the last of the list, you need to go back prev page.
    if (pagination.pageNumber > 1 && list.length === 1) {
      setPagination(current => ({
        ...current,
        pageNumber: current.pageNumber - 1,
      }));
    }
  };

  return {
    loading: loading || deleteLoading,
    data: list,
    totalCount: listTotalCount,
    filter: queryFilter,
    refetch: advancedRefetch,
    pagination,
    setPagination,
    setQueryFilter,
    deleteItem: advancedDelete,
  };
}
